import { render } from "./ProductBoxSegmentImage.vue?vue&type=template&id=18ecd3fe&ts=true"
import script from "./ProductBoxSegmentImage.vue?vue&type=script&lang=ts"
export * from "./ProductBoxSegmentImage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__